import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "connect",
  "use": "connect-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"connect\">\r\n\t<path d=\"M568 680v56h56V960h-224v-224h56v-56h-192C153.536 680 64 594.432 64 484.032V264A200 200 0 0 1 264 64h496A200 200 0 0 1 960 264v220.032c0 110.464-89.536 195.968-200 195.968h-192zM848 288c0-77.312-45.696-112-112-112h-448c-66.304 0-112 34.688-112 112v168c0 77.312 45.696 112 112 112h448c66.304 0 112-34.688 112-112V288zM960 848h-280v-56H960v56z m-896 0h280v-56H64v56z\" fill=\"currentColor\">\r\n\t</path>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol